<div class="center-text" *ngIf="showPagination">
  <dgx-pagination
    [(page)]="pageNum"
    [collectionSize]="totalContentResults"
    [boundaryLinks]="true"
    [ellipses]="false"
    [maxSize]="8"
    [pageSize]="numResultsPerPage"
    [rotate]="true"
    (pageChange)="pageChange.emit($event)"
  >
  </dgx-pagination>
</div>
